<template>
  <div class="drawer-wrapper" v-loading.fullscreen.lock="loading">
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="dialogVisible" size="50%"
               :before-close="handleClose" direction="rtl">

      <div class="demo-drawer__content">
        <el-form :model="addFrom" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="名称" prop="name" :label-width="formLabelWidth">
                <el-input v-model="addFrom.name" placeholder="请输入名称" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="排序" prop="listorder" :label-width="formLabelWidth">
                <el-input v-model="addFrom.listorder" placeholder="排序" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {apis} from "@/api/infos";
import {processErrors} from "@/utils/errorHandler";
const api = apis();
export default {
  props: ['dialogVisible', "editID", "type"],
  components: {},
  data() {
    return {
      title: "新增",
      formLabelWidth: "140px",
      addFrom: {
        name: "",
        listorder:''
      },
	  loading: false,
	  isask: false,
      rules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
        ],
        listorder: [
          {required: true, message: '排序', trigger: 'blur'},
        ]
      },
    };
  },
  mounted() {
    if (this.editID != "") {
      this.loading = true
      api.ApiCategoryInfo({id: this.editID}).then(res => {
		this.loading = false
        if (res.code == 0) {
          this.title = "编辑"
          this.addFrom = res.data
        } else {
          processErrors(res);
        }
      })
    }
  },
  methods: {
    handleClose(done) {
      this.$emit('NoneDlog');
      this.$refs['ruleForm'].resetFields();
    },

    AddNone() {
      this.addFrom = {
        name: "",
        listorder:''
      }
      this.title = ""
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },

    addPush() {
	  if(this.isask){
		  return;
	  }
      this.loading = true
	  this.isask = true;
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let createText = ''
		  this.addFrom.type = this.type
          if (this.editID == "") {
            createText = "创建成功";
          } else {
            this.addFrom.id = this.editID
            createText = "修改成功";
          }

          api.ApiCategoryEdit(this.addFrom).then(res => {
			this.isask = false;
			this.loading = false;
            if (res.code == 0) {
              this.$message({
                message: createText,
                type: 'success'
              });
              this.$emit('AddOk');
            } else {
              processErrors(res);
            }
          })
        } else {
          return false;
        }
      });
    }
  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  margin-top: 20px;
  overflow-x: hidden;
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}
</style>